'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_content_Target() {
}
export { $c_Lio_intela_sites_intelacloud_content_Target as $c_Lio_intela_sites_intelacloud_content_Target };
$p = $c_Lio_intela_sites_intelacloud_content_Target.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_intelacloud_content_Target;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_content_Target() {
}
export { $h_Lio_intela_sites_intelacloud_content_Target as $h_Lio_intela_sites_intelacloud_content_Target };
$h_Lio_intela_sites_intelacloud_content_Target.prototype = $p;
$p.O = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
//# sourceMappingURL=io.intela.sites.intelacloud.content.-Target.js.map
